import { render, staticRenderFns } from "./SourceCodeModeler.vue?vue&type=template&id=4180f1ba"
import script from "./SourceCodeModeler.vue?vue&type=script&lang=js"
export * from "./SourceCodeModeler.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports